import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { ContentIdea } from './ideaStore';

interface SavedIdeasStore {
  savedIdeas: ContentIdea[];
  saveIdea: (idea: ContentIdea) => void;
  removeIdea: (idea: ContentIdea) => void;
}

export const useSavedIdeasStore = create<SavedIdeasStore>()(
  persist(
    (set) => ({
      savedIdeas: [],
      saveIdea: (idea) =>
        set((state) => ({
          savedIdeas: [...state.savedIdeas, idea],
        })),
      removeIdea: (idea) =>
        set((state) => ({
          savedIdeas: state.savedIdeas.filter(
            (saved) => saved.title !== idea.title
          ),
        })),
    }),
    {
      name: 'saved-ideas',
      storage: createJSONStorage(() => localStorage),
      version: 1,
      migrate: (persistedState: any, version: number) => {
        if (version === 0) {
          return {
            ...persistedState,
            savedIdeas: []
          };
        }
        return persistedState;
      }
    }
  )
);